import { createSelector } from '@ngrx/store';

import { paymentState } from '../root';

export const getPaymentErrors = createSelector(paymentState, (payment) => payment.errors);
